// libs
import React, { memo } from 'react';

// defs
import { ICategoryData } from 'shared/api/mega-menu/types';

// styles
import { TitleContainer, Icon, Button } from './styles';

// components
import ContentRenderer from 'shared/components/Header/DesktopHeaderV2/components/Menu/components/SubMenu/components/ContentRenderer';

// context
import { useMenuContext } from 'shared/components/Header/DesktopHeaderV2/components/Menu/components/Context';

interface ISubMenuItemProps {
  itemData: ICategoryData;
  idx: number;
}

function SubMenuItem({ itemData, idx }: ISubMenuItemProps) {
  const { activeSubMenuItem, setActiveSubMenuItem } = useMenuContext();

  const shouldShowContent = activeSubMenuItem === itemData.name;

  const showContent = () => setActiveSubMenuItem(itemData.name);
  const hideContent = () => setActiveSubMenuItem('');

  const classNames = shouldShowContent ? 'flipped' : '';

  return (
    <Button onMouseLeave={hideContent} onClick={showContent} onMouseEnter={showContent}>
      <TitleContainer selected={shouldShowContent}>
        {itemData.name}
        <Icon className={`icon-arrow ${classNames}`} />
      </TitleContainer>

      {shouldShowContent && <ContentRenderer idx={idx} tertiaryContent={itemData.children_data} />}
    </Button>
  );
}

export default memo(SubMenuItem);
